var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { columnsToNumeral } from '../../utilities/SemanticUtils';
export const GridRow = (_a) => {
    var { centered, children, className, el: TagName = 'div', columns, divided, only, reversed, stretched, textAlign, verticalAlign } = _a, props = __rest(_a, ["centered", "children", "className", "el", "columns", "divided", "only", "reversed", "stretched", "textAlign", "verticalAlign"]);
    // Composing classes out of "reversed" prop
    const reversedSet = new Set(typeof reversed === 'string'
        ? reversed.trim().split(' ').filter(Boolean)
        : []);
    const reversedClasses = ['mobile', 'tablet', 'desktop']
        .filter((device) => reversedSet.has(device))
        .map((device) => reversedSet.has('vertically')
        ? `GridRow--${device}-vertically-reversed`
        : `GridRow--${device}-reversed`);
    const GridRowClasses = classnames('GridRow', className, reversedClasses, {
        'GridRow--centered': centered,
        [`GridRow--${columnsToNumeral(columns)}-columns`]: columnsToNumeral(columns),
        'GridRow--equal-width': columns === 'equal',
        'GridRow--divided': divided,
        [`GridRow--${only}-only`]: only,
        'GridRow--stretched': stretched,
        [`GridRow--text-align-${textAlign}`]: textAlign,
        [`GridRow--vertical-align-${verticalAlign}`]: verticalAlign,
    });
    return (React.createElement(TagName, Object.assign({ className: GridRowClasses }, props), children));
};
//# sourceMappingURL=GridRow.js.map